export default __webpack_public_path__ + "static/media/r3.239390a1.jpg";